import { EditGroupsTableQuery } from '@website/types/graphqlOperations';

/**
 * Sum the (active) spaces booked for a group
 */
export default function sumSpacesBooked(
  group: EditGroupsTableQuery['trip']['groups']['items'][0],
): number {
  return group.bookings.items.reduce(
    (prev, curr) => prev + curr.spaces.filter((sp) => sp.active).length,
    0,
  );
}
